import { Alert, Code, Text } from "@mantine/core";

import { errorReference, toUserMessage } from "./messages";

/**
 * A failed call, said in words, where it happened: no toasts (audit frontend A.5). `role="alert"`
 * makes screen readers announce it.
 */
export function ErrorAlert({ error }: { error: unknown }) {
  const reference = errorReference(error);
  return (
    <Alert color="red" variant="light" role="alert">
      <Text size="sm">{toUserMessage(error)}</Text>
      {reference === undefined ? null : (
        <Text size="xs" c="var(--cai-color-text-muted)">
          Reference: <Code>{reference}</Code>
        </Text>
      )}
    </Alert>
  );
}
